
import { getLang } from "@/plugins/env"
import iconWarning from "@/assets/images/warning.svg"
import iconLocation from "@/assets/images/location.svg"
import iconSweatFace from "@/assets/images/sweat_face.svg"

export default {
  name: "DshopException",
  props: {
    code: {
      type: String,
      default: ""
    }
  },
  serverCacheKey: props => {
    return `${getLang()}_DshopException_${props.code}`
  },
  computed: {
    statusMap() {
      const code = this.code
      const retryText = this.$t("dshop.retry")
      const goToHomepageText = this.$t("dshop.goToHomepage")
      return {
        1001: {
          title: this.$t("dshop.activityNotStarted", { code }), // 活动未上线
          btnText: goToHomepageText,
          handler: this.goHome,
          icon: iconSweatFace
        },
        1002: {
          title: this.$t("dshop.activityNotStarted", { code }), // 活动未开始
          btnText: goToHomepageText,
          handler: this.goHome,
          icon: iconSweatFace
        },
        1003: {
          title: this.$t("dshop.activityOver", { code }), // 活动已结束
          btnText: goToHomepageText,
          handler: this.goHome,
          icon: iconSweatFace
        },
        1004: {
          title: this.$t("dshop.activityOver", { code }), // 访问活动的结束页面不在定位范围内
          btnText: goToHomepageText,
          handler: this.goHome,
          icon: iconSweatFace
        },
        1005: {
          title: this.$t("dshop.activityRegionNotMatch", { code }), // 活动不在定位范围内
          btnText: goToHomepageText,
          handler: this.goHome,
          icon: iconLocation,
          header: this.$t("dshop.storeIsNotAvailable")
        },
        1006: {
          title: this.$t("dshop.activitySorryWrong", { code }), // 活动页面渲染出错
          btnText: retryText,
          handler: this.retry,
          icon: iconWarning
        }
      }
    },
    error() {
      return this.statusMap[this.code] || this.statusMap["1006"]
    }
  },
  methods: {
    retry() {
      window.location.reload()
    },
    goHome() {
      window.location.href = `${this.MAIN_ORIGIN_HOME}`
    }
  }
}
